import React, { Component } from 'react'
import { Link, Redirect } from "react-router-dom"
import { Badge } from 'reactstrap'
import ConfirmDelete from '../../../../components/ConfirmDelete'
import ButtonsGrid from '../../../../components/ButtonsGrid'
import Table from '../../../../components/Table'
import auth from '../../../../utils/auth'
import cfg from '../../../../utils/config'
import axios from 'axios'
import { lnsStatus } from '../../../../utils/Enums/lnsStatus'

class GridDevices extends Component {
    applicationId = this.props.applicationId
    clienteApplicationId = this.props.clienteId

    state = {
        data: [],
        loading: true,
        redirectToEdit: false,
        table: null
    }

    getData = (state) => {
        this.setState({ loading: true })
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        let userInfo = auth.getUserInfo()
        let url = cfg.base_api_url + cfg.api_v2 + '/' + userInfo.empresa + `/lns/application/${this.applicationId}/device/?limit=` + state?.lineCount + state.filter

        if (state.url) {
            url = state.url
        }

        axios.get(url, config_me).then((res) => {
            this.setState({
                loading: false,
                data: res.data.results,
                count: res.data.count,
                next: res.data.next,
                previous: res.data.previous
            })
        })
    }

    deletar = () => {
        let requestArray = []
        let userInfo = auth.getUserInfo()
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }
        this.setState({ loading: true, enableDeletar: false, enableEditar: false })

        this.state?.table?.state.selected.map((value, index) =>
            requestArray.push(axios.delete(cfg.base_api_url + cfg.api_v2 + `/${userInfo.empresa}/lns/application/${this.applicationId}/device/${value}/`, config_me))
        )

        axios.all(requestArray).then(axios.spread((acct, perms) => {
            this.state?.table?.fetch()
            this.state?.table?.unselect()
        }))
    }

    editar = () => {
        let toGo = `/lns/application/${this.applicationId}/device/` + this.state?.table?.state.selected?.[0] + "/editar"

        if(this.clienteApplicationId) {
            toGo = `/lns/application/${this.applicationId}/device/` + this.state?.table?.state.selected?.[0] + `/editar/${this.clienteApplicationId}`
        }

        let from = { pathname: toGo }
        this.setState({ redirectToEdit: from })
    }

    convertDate = (date) => new Date(Date.parse(date)).toLocaleDateString('pt-BR',
        { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' }
    )

    render() {
        const { redirectToEdit, table } = this.state
        if (redirectToEdit) {
            return <Redirect to={redirectToEdit} />
        }

        const columns = [
            {
                Header: 'Nome',
                Accessor: 'name',
                Cell: (original) => {
                    if(this.clienteApplicationId) {
                        return <Link to={`/lns/application/${this.applicationId}/device/${original.id}/editar/${this.clienteApplicationId}`}>{original.name}</Link>
                    } else {
                        return <Link to={`/lns/application/${this.applicationId}/device/${original.id}/editar`}>{original.name}</Link>
                    }
                }
            }, 
            {
                Header: 'Perfil do dispositivo',
                Accessor: 'device_profile_name'
            }, 
            {
                Header: 'Dispositivo EUI',
                Accessor: 'dev_eui'
            },
            {
                Header: 'Status',
                Accessor: 'state',
                Cell: ({ state }) => {
                    switch(lnsStatus[state]) {
                        case 'Ativo':
                            return <Badge color="success">Ativo</Badge>
                        case 'Sem Comunicação':
                            return <Badge color="danger">Sem comunicação</Badge>
                        case 'Nunca comunicou':
                            return <Badge color="secondary">Nunca comunicou</Badge>
                        case 'Inativo':
                            return <Badge color="secondary">Inativo</Badge>
                        default:
                            return <Badge color="secondary">---</Badge>
                    }
                }
            },
            {
                Header: 'Última comunicação',
                Accessor: 'last_seen_at',
                Cell: ({ last_seen_at }) => {
                    let result = last_seen_at ? this.convertDate(last_seen_at) : "---"
                    return <span>{result}</span>
                }
            }, 
            {
                Header: 'Criado em',
                Accessor: 'created_at',
                Cell: (original) => {
                    return <span>{this.convertDate(original.created_at)}</span>
                }
            }, 
            {
                Header: 'Atualizado em',
                Accessor: 'updated_at',
                Cell: (original) => {
                    return <span>{this.convertDate(original.updated_at)}</span>
                }
            },
            {
                Header: 'Redirecionamento',
                Accessor: 'redirecionamento',
                Cell: (original) => {
                    if(original?.redirecionamento?.id) {
                        return <Link to={`/lns/redirecionamentos/${original?.redirecionamento?.id}/editar`}>{original?.redirecionamento?.nome}</Link>
                    } else {
                        return  <span>---</span>
                    }
                }
            },
        ]

        return (
            <>
                <div>
                    <div className="hdv-btn-group">
                        <ButtonsGrid
                            route="/device"
                            buttons={[
                                {
                                    method: "post",
                                    button: <Link 
                                    to={this.clienteApplicationId ? `/lns/application/${this.applicationId}/device/novo/${this.clienteApplicationId}` : `/lns/application/${this.applicationId}/device/novo`}>
                                        <button className="hdv-btn-forms hdv-btn-green ">Novo</button>
                                    </Link>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={table?.state.enableEditar ? this.editar : null} className={"hdv-btn-forms hdv-btn-yellow " + (table?.state.enableEditar ? "" : "hdv-btn-disable")}>Editar</button>
                                },

                                {
                                    method: "delete",
                                    button: <ConfirmDelete enabled={table?.state.enableDeletar} action={this.deletar} />
                                }
                            ]}
                        />
                    </div>
                    
                    <Table
                        checkbox
                        notEditFirstColum={true}
                        data={this.state.data}
                        loading={this.state.loading}
                        count={this.state.count}
                        next={this.state.next}
                        previous={this.state.previous}
                        columns={columns}
                        onFetchData={this.getData}
                        onUpdate={(table) => this.setState({ table })}
                    />
                </div>
            </>
        )
    }
}

export default GridDevices